import {
  AgAirline,
  AgInput,
  AgSelect,
  AgSelect1,
  AgUnloc,
  AgTextareaInput,
} from "../components/AgComponents.js";
import Api from "../state/Api.js";
import { Columns, Col, Col2, Col3, Col4, Col6, Col12 } from "../Controls.js";
import {
  getStaticConsolidatorList,
  commodityList,
  hazardousList,
  warehouses,
  chargeTypeList,
} from "../StaticData.js";
import {
  configStore,
  quoteDataRec,
  chargesStore1,
  airChargesStore,
  customerStore,
  entityStore,
  aguserStore,
  multiSelectListStore,
  dataListStore,
  modalStore,
  EntityV2Store,
  AgmodalStore,
  quoteDataRec_inti,
  loginStore,
} from "../state/CommonState.js";
import { containerStore, cargoStore } from "../state/CommonState.js";
import { incoTermsList } from "../StaticData.js";
import { proxy, useSnapshot } from "valtio";
import { chargesData1 } from "../StaticData.js";
import { fclChargesStore } from "../state/CommonState.js";
import Utils from "../util/Utils.js";
import AgCustlist, { AgSelectNew } from "../components/AgCustlist.js";
import { useEffect, useLayoutEffect, useState, useRef } from "react";
import {
  AgMultiSelectWithCheckBoxes,
  AgSelectWithMap,
} from "../components/AgCustomComponents.js";
import {
  chargesValidationStore,
  QuotationValidationStore,
} from "../state/validation-stores.js";
import { SHIPMENT_SCOPE } from "../util/quotationUtil.js";
import AguserApi from "../state/AguserApi.js";
import LCLChargesCompv3 from "../quotesv3/lcl-charges-v3.js";
import AirChargesCompv3 from "../quotesv3/air-charges-v3.js";
import FCLChargesCompv3 from "../quotesv3/fcl-charges-v3.js";
import VehicleViewv3 from "../quotesv3/vehicle-view-v3.js";
import RoleUtils from "../util/RoleUtils.js";
import { PERMISSIONS } from "../util/constants.js";
import { taskStore } from "../mytasks/task-store.js";
import EntityV2Api from "../state/entities-api.js";
import { useForm } from "react-hook-form";
import { Quotation } from "../state/Types.js";
import { Cargo, Container } from "../enquiry/enquiry-data.js";
import { ActiveTab } from "../v3-componets/AgActiveTab.js";
import { Route } from "../v3-componets/AgRoute.js";
import { Details } from "../v3-componets/AgDetails.js";
import { Headspan } from "../v3-componets/AgHeadspan.js";
import { Card } from "reactstrap";
import ship1 from "../assets/images/ship1.svg";
import TenantUtils from "../util/tenant.utils.js";
import on from "../components/on2.png";
import off from "../components/off.png";
import { textAlign } from "@mui/system";
import { editapprovalStore } from "../quote-approval/editapprovalStore.js";
import QuoteEditCharge from "./quote-editcharge.js";
import CopyMail from "./copymail.js";

export default function QuoteRateRequest() {
  useSnapshot(configStore);
  useSnapshot(customerStore);
  useSnapshot(multiSelectListStore);
  useSnapshot(dataListStore);
  useSnapshot(modalStore);
  useSnapshot(entityStore);
  useSnapshot(loginStore);
  useSnapshot(aguserStore);

  useSnapshot(EntityV2Store);
  useSnapshot(taskStore);
  let rec1 = useSnapshot(quoteDataRec);
  const rec = useSnapshot(quoteDataRec_inti);
  useSnapshot(QuotationValidationStore);
  const selectedConsolidatorList = getStaticConsolidatorList();
  const consolidatorListKey = "consolidatorList";
  const [cursor, setCursor] = useState(0);
  const ref = useRef(null);
  const [entitieslist, setEntitieslist] = useState([]);
  const [prList, setPrList] = useState([]);
  const [prListglobal, setPrListglobal] = useState([]);
  const [rmcs, setRmcs] = useState([]);
  const [agActiveList, setAgActiveList] = useState([]);
  const [clickSave, setClickSave] = useState(false);
  const [clickContract, setClickContact] = useState(false);
  const [reviseCharges, setReviseCharges] = useState(false);
  const [openCopyMail, setOpenCopyMail] = useState(false)
  const [airName, setAirName] = useState({});
  const [isNomination, setIsNomination] = useState(false);
  const [currentTradeType, setcurrentTradeType] = useState("");
  const [entityCountry, setEntityCountry] = useState("");
  const [entityDataobj, setentityDataobj] = useState({});

 
  const addprlist = (e, pr) => {
    if (e.length > 0) {
      if (JSON.stringify(rmcs) != JSON.stringify(e)) {
        setRmcs(e);
      }
      let l = [];
      let k = [];
      if (pr == undefined) {
        pr = prList;
      }
      for (let j = 0; j < pr.length; j++) {
        k.push(pr[j]["value"]);
        l.push(pr[j]);
      }
      for (let i = 0; i < e.length; i++) {
        if (
          e[i] != undefined &&
          e[i].email != undefined &&
          k.indexOf(e[i].email) == -1
        ) {
          k.push(e[i].email);
          l.push({
            label: `${e[i]["firstName"]} ${e[i]["lastName"]} (${e[i]["email"]})`,
            value: e[i]["email"],
          });
        }
      }
      if (JSON.stringify(l) != JSON.stringify(prListglobal)) {
        setPrListglobal(l);
      }
    } else {
      if (pr != undefined) {
        if (JSON.stringify(pr) != JSON.stringify(prListglobal)) {
          setPrListglobal(pr);
        }
      } else {
        if (JSON.stringify(prList) != JSON.stringify(prListglobal)) {
          setPrListglobal(prList);
        }
      }
    }
  };

  useEffect(() => {
    if (rmcs.length > 0 && prList.length > 0) {
      addprlist(rmcs, prList);
    }
  }, [rmcs, prList, prListglobal]);
  useLayoutEffect(() => {
    let list = [];
    if (quoteDataRec.isfromAgragaEnquiry == "Yes") {
      let v2StoreList = EntityV2Store.list;
      for (let i = 0; i < v2StoreList.length; i++) {
        if (
          v2StoreList[i]["entityName"] === "YET TO BE ASSIGNED" ||
          v2StoreList[i]["entityType"] === "Customer" ||
          (v2StoreList[i]["entityType"] === "Vendor" &&
            v2StoreList[i]?.vendor?.isChannelPartner == true)
        ) {
          list.push(v2StoreList[i]);
        }
      }
    } else {
      for (let i = 0; i < EntityV2Store.Cuslist.length; i++) {
        if (EntityV2Store.Cuslist[i]["entityName"] != "YET TO BE ASSIGNED") {
          list.push(EntityV2Store.Cuslist[i]);
        }
      }
    }
    if (JSON.stringify(EntityV2Store.list) != list) {
      setEntitieslist(list);
    }
  }, [quoteDataRec.isfromAgragaEnquiry, EntityV2Store.list]);
  const getExchangerates = async () => {
    await Api.getExchangerates();
  };
  useEffect(() => {
    const agactiveuserlist = () => {
      let l = [];
      if (TenantUtils.isNavexel()) {
        l.push({
          label: "Agent",
          value: "Agent",
        });
      }
      for (let i = 0; i < aguserStore.list.length; i++) {
        let e = aguserStore.list[i];
        if (
          e["status"] == "ACTIVE" &&
          e["email"].indexOf(`@${process.env.REACT_APP_ENTERPRISE_DOMAIN}`) !=
            -1
        ) {
          l.push({
            label: `${e["firstName"]} ${e["lastName"]} (${e["email"]})`,
            value: `${e["firstName"]} ${e["lastName"]} (${e["email"]})`,
          });
        }
      }
      if (JSON.stringify(agActiveList) != JSON.stringify(l)) {
        setAgActiveList(l);
      }
    };
    agactiveuserlist();
  }, [aguserStore.list]);
  useEffect(() => {
    console.log("Inside useEffect of Quote ");
    getExchangerates();
    Api.getFCLCarrierList();
    AguserApi.getList();
  }, []);
  useEffect(() => {
    const pruserlist = (data) => {
      let l = [];
      let user = false;
      for (let i = 0; i < data.length; i++) {
        if (loginStore?.userRec?.email.trim() == data[i]["email"].trim()) {
          user = true;
        }
        l.push({
          label: `${data[i]["firstName"]} ${data[i]["lastName"]} (${data[i]["email"]})`,
          value: data[i]["email"],
        });
      }
      if (!user) {
        l.push({
          label: `${loginStore?.userRec?.firstName} ${loginStore?.userRec?.lastName} (${loginStore?.userRec?.email})`,
          value: loginStore?.userRec?.email,
        });
      }
      if (JSON.stringify(prList) != JSON.stringify(l)) {
        setPrList(l);
        setPrListglobal(l);
        if (rmcs.length > 0) {
          addprlist(rmcs, l);
        }
      }
    };
    if (quoteDataRec && quoteDataRec.shipmentType) {
      switch (true) {
        case quoteDataRec.shipmentType.toLowerCase().indexOf("fcl") >= 0:
          AguserApi.getUsers4role_new("FCL Procurement", pruserlist);
          break;
        case quoteDataRec.shipmentType.toLowerCase().indexOf("lcl") >= 0:
          AguserApi.getUsers4role_new("LCL Procurement", pruserlist);
          break;
        case quoteDataRec.shipmentType.toLowerCase().indexOf("air") >= 0:
          AguserApi.getUsers4role_new("AIR Procurement", pruserlist);
          break;
      }
    }
  }, [quoteDataRec.shipmentType]);
  useEffect(() => {
    const input = ref.current;
    if (input) {
      input.setSelectionRange(cursor, cursor);
    }
  }, [ref, cursor]);
  const handleChange = (e) => {
    setCursor(e.target.selectionStart);
    quoteDataRec.customTC = e.target.value;
  };
  const handleChange1 = (e, i) => {
    setCursor(e.target.selectionStart);
    quoteDataRec.multicharge[i].customTC = e.target.value;
  };
  useLayoutEffect(() => {
    if (
      quoteDataRec?.shipmentType != "" &&
      quoteDataRec?.shipmentType.toLowerCase().includes("lcl")
    ) {
      if (!quoteDataRec?.quotationNum && quoteDataRec?.consolidatorList == null)
        quoteDataRec.consolidatorList = selectedConsolidatorList;
      multiSelectListStore.selectList[consolidatorListKey] =
        selectedConsolidatorList.map(({ consolidatorAbbrName, scacCode }) => ({
          id: consolidatorAbbrName,
          name: consolidatorAbbrName,
          scacCode: scacCode,
          checked: quoteDataRec.consolidatorList
            .map((addedConsolidator) => addedConsolidator.consolidatorAbbrName)
            .includes(consolidatorAbbrName),
        }));
    } else quoteDataRec.consolidatorList = null;
  }, [quoteDataRec.consolidatorList, quoteDataRec.shipmentType]);

  const _params = (label, name, type = "text", dataList = []) => {
    return {
      type,
      name,
      label,
      record: quoteDataRec,
      dataList,
    };
  };

  const portOfReceiptLable =
    quoteDataRec.shipmentType.indexOf("Air") >= 0
      ? "* Airport of Receipt"
      : "Place of Receipt";
  const portOfLoadingLabel =
    quoteDataRec.shipmentType.indexOf("Air") >= 0
      ? "* Airport of departure"
      : "* Port of Loading";
  const portOfDischargeLabel =
    quoteDataRec.shipmentType.indexOf("Air") >= 0
      ? "* Airport of Arrival"
      : "Port of Discharge";

  let buttontext = "Save";
  if (quoteDataRec.status == "DRAFT(Enquiry)") {
    buttontext = "SUBMIT";
  } else {
    buttontext = "Save";
  }
  useEffect(() => {
    if (
      quoteDataRec.scac != undefined &&
      quoteDataRec.scac.length > 0 &&
      quoteDataRec?.shipmentType.toLowerCase().includes("fcl")
    ) {
      for (let i = 0; i < dataListStore["FCLCarrierList"].length; i++) {
        let l = dataListStore["FCLCarrierList"][i];
        if (l["SCAC code"] == quoteDataRec.scac) {
          let l1 = `${l["Display Name"]} (${l["SCAC code"]})`;
          if (
            quoteDataRec.multicharge != undefined &&
            quoteDataRec.multicharge.length > 0
          ) {
            if (quoteDataRec.multicharge[0].carrier != l1) {
              quoteDataRec.multicharge[0].carrier = l1;
              quoteDataRec.scac = "";
            }
          }
        }
      }
    }
  }, [
    JSON.stringify(dataListStore["FCLCarrierList"]),
    JSON.stringify(quoteDataRec),
  ]);

  const getEntityData = async () => {
    if (!quoteDataRec.entityId) {
      setentityDataobj({});
      quoteDataRec.salesperson = "";
      quoteDataRec.customerService = "";
      return "";
    }
    let entity;
    if (!entityDataobj?.entityId?.length > 0) {
      entity = await EntityV2Api.viewEntity(quoteDataRec.entityId);
      setentityDataobj(entity);
    } else {
      entity = entityDataobj;
    }
    console.warn("FOUND ENTITY = ", entity);
    if (entity) {
      let k = [];
      // let email = entity?.customer?.crossBorder?.relationshipManagers[0].email;
      quoteDataRec.entityName = entity.entityName;
      let rmEmailList = entity?.customer?.crossBorder?.relationshipManagers;
      let csEmailList = entity?.customer?.crossBorder?.customerService;
      let shipmentType = quoteDataRec.shipmentType;
      let tradetype = "";
      let country = entity.entityCountry.toLowerCase();
      setEntityCountry(country);
      let por = quoteDataRec.portOfReceipt.toLowerCase();
      let fpod = quoteDataRec.finalPlaceOfDelivery.toLowerCase();
      if (shipmentType.toLowerCase() === "air") {
        por = quoteDataRec.portOfLoading.toLowerCase();
        fpod = quoteDataRec.portOfDischarge.toLowerCase();
      }
      tradetype = Utils.getTrade(country, por, fpod);
      if (
        quoteDataRec.tradeType == undefined ||
        quoteDataRec.tradeType != tradetype
      ) {
        quoteDataRec.tradeType = tradetype;
      }
      if (tradetype === "") {
        tradetype = "Export";
      }
      setcurrentTradeType(tradetype);
      // if(por.includes(country)) tradetype = "Import"
      // else if (fpod.includes(country)) tradetype = "Export"
      if (
        quoteDataRec.salesperson == undefined ||
        (quoteDataRec.salesperson != undefined &&
          quoteDataRec.salesperson.length === 0)
      ) {
        let rmemails = Utils.getRelationShipMangerForType(
          rmEmailList,
          shipmentType,
          tradetype,
          quoteDataRec.nomination,
        );
        if (rmemails && rmemails?.length > 0 && rmemails[0]?.email.length > 0) {
          rmemails.map((x, y) => {
            k.push(aguserStore.getdetails(x.email));
          });
          quoteDataRec.salesperson = aguserStore.getName4email(
            rmemails[0]?.email,
          );
          //  QuotationValidationStore.quotationValidMap.salesperson = aguserStore.getName4email(rmemails[0]?.email)
        } else {
          quoteDataRec.salesperson = "";
          // QuotationValidationStore.quotationValidMap.salesperson = ""
        }
      }
      // email = entity?.customer?.crossBorder?.customerService[0].email;
      if (
        quoteDataRec.customerService == undefined ||
        (quoteDataRec.customerService != undefined &&
          quoteDataRec.customerService.length == 0)
      ) {
        let csemails = Utils.getCustomerServiceForType(
          csEmailList,
          shipmentType,
          tradetype,
          quoteDataRec.nomination,
        );
        if (csemails && csemails?.length > 0 && csemails[0]?.email.length > 0) {
          csemails.map((x, y) => {
            k.push(aguserStore.getdetails(x.email));
          });
          quoteDataRec.customerService = aguserStore.getName4email(
            csemails[0]?.email,
          );
          // QuotationValidationStore.quotationValidMap.customerService = aguserStore.getName4email(rmemails[0]?.email)
        } else {
          quoteDataRec.customerService = "";
          //  QuotationValidationStore.quotationValidMap.customerService = ""
        }
      }
      addprlist(k);
    }
  };
  // const [selectedType, setType] = useState("LCL");
  const defaultType = Utils.getAuthProductList(["LCL", "FCL", "Air"])[0] || "";
  const [selectedType, setType] = useState(defaultType);
  const md = [
    {
      destination: "",
      cargoDetails: [new Cargo()],
    },
  ];

  useEffect(() => {
    getEntityData();
    console.log("quoteDataRec", quoteDataRec);
  }, [
    quoteDataRec.entityId,
    quoteDataRec.nomination,
    quoteDataRec.shipmentType,
    currentTradeType,
  ]);

  const checkTradetypefn = async () => {
    console.log("quoterec", quoteDataRec);
    if (
      !quoteDataRec.entityId ||
      !quoteDataRec.portOfReceipt ||
      !quoteDataRec.finalPlaceOfDelivery ||
      (quoteDataRec.shipmentType.toLowerCase() === "air" &&
        (!quoteDataRec.portOfLoading || !quoteDataRec.portOfDischarge)) ||
      !entityCountry ||
      !shipmentType
    ) {
      return "";
    }
    let tradetype = "";
    let country = entityCountry.toLowerCase();
    let por = quoteDataRec.portOfReceipt.toLowerCase();
    let fpod = quoteDataRec.finalPlaceOfDelivery.toLowerCase();
    if (shipmentType?.toLowerCase() === "air") {
      por = quoteDataRec.portOfLoading.toLowerCase();
      fpod = quoteDataRec.portOfDischarge.toLowerCase();
    }
    tradetype = Utils.getTrade(country, por, fpod);
    if (tradetype !== currentTradeType && currentTradeType !== "") {
      quoteDataRec.salesperson = "";
      quoteDataRec.customerService = "";
      setcurrentTradeType(tradetype);
    } else {
      setcurrentTradeType(tradetype);
    }
  };

  useEffect(() => {
    checkTradetypefn();
  }, [
    quoteDataRec.portOfReceipt,
    quoteDataRec.finalPlaceOfDelivery,
    quoteDataRec.portOfLoading,
    quoteDataRec.portOfDischarge,
  ]);

  const cargoForm = useForm({
    defaultValues: {
      mode: selectedType,
      orginScope: false,
      destinationScope: false,
      originType: false,
      destinationType: false,
      showCargoDetailsOutGuage: false,
      showPalletLabel: false,
      scope: SHIPMENT_SCOPE.P2P,
      multidest: md,
      containerDetails: [new Container()],
    },
  });
  const {
    control,
    watch,
    register,
    setValue,
    handleSubmit,
    reset,
    clearErrors,
    formState: { errors },
    trigger,
    getFieldState,
    getValues,
  } = cargoForm;
  useSnapshot(cargoStore);
  const [show, setShow] = useState(false);
  const [recdumb, setRecdumb] = useState({});  


  
 
  useEffect(() => {
    if (
      quoteDataRec.quotationNum == "" &&
      configStore.disableShipmentType == ""
    ) {
      let quoteDataRec = proxy(new Quotation());
      if (selectedType == "FCL") {
        quoteDataRec.shipmentType = `FCL (Factory/Factory)`;
        setValue("shipmentType", "FCL (Factory/Factory)");
      } else {
        quoteDataRec.shipmentType = selectedType;
        setValue("shipmentType", selectedType);
      }
      setValue("origin", "");
      setValue("multidest", md);
    }
    setValue("mode", selectedType);

    clearErrors();
  }, [selectedType]);

  const cargoReadinessDate = watch("cargoreadinessdate");
  const shipmentScope = watch("scope");
  const hazardous = watch("hazardous");
  const shipmentType = watch("shipmentType");
  const multidest = watch("multidest");
  const cargoDimensionUnit = watch("cargoDimensionUnit");
  const showCargoDetailsOutGuage = watch("showCargoDetailsOutGuage");
  const stuffingType = watch("stuffingType");
  const destuffingType = watch("destuffingType");
  const mode = watch("mode");
  const containerDetails = watch("containerDetails");
  console.log(" the rec is ", rec);
  
  useEffect(() => {
    if (
      quoteDataRec.quotationNum == undefined ||
      quoteDataRec.quotationNum.length == 0
    ) {
      if (
        quoteDataRec.shipmentType != shipmentType &&
        shipmentType != undefined
      ) {
        quoteDataRec.shipmentType = shipmentType;
      }
      let b = ["Factory", "Factory"];
      if (quoteDataRec.shipmentType.indexOf("FCL") != -1) {
        const a = quoteDataRec.shipmentType;
        b = [];
        b = a.match(/\(([^)]+)\)/)[1].split("/");
      }
      if (
        quoteDataRec.stuffingType != stuffingType &&
        stuffingType != undefined &&
        b[0] == stuffingType
      ) {
        quoteDataRec.stuffingType = stuffingType;
      }
      if (
        quoteDataRec.destuffingType != destuffingType &&
        destuffingType != undefined &&
        b[1] == destuffingType
      ) {
        quoteDataRec.destuffingType = destuffingType;
      }
    }
  }, [shipmentType, stuffingType, destuffingType]);
  useEffect(() => {
    if (show) {
      if (
        quoteDataRec.cargoReadinessDate != cargoReadinessDate &&
        cargoReadinessDate != undefined
      ) {
        quoteDataRec.cargoReadinessDate = cargoReadinessDate;
        quoteDataRec.validUpto = "";
        if (
          quoteDataRec.multicharge != undefined &&
          quoteDataRec.multicharge.length > 0
        ) {
          for (let i = 0; i < quoteDataRec.multicharge.length; i++) {
            if (
              quoteDataRec.multicharge[i]["cargoReadinessDate"] !=
              cargoReadinessDate
            ) {
              quoteDataRec.multicharge[i]["cargoReadinessDate"] =
                cargoReadinessDate;
              quoteDataRec.multicharge[i]["validUpto"] = "";
            }
          }
        }
      }
      
      let h = hazardous == false || hazardous == undefined ? "No" : "Yes";
      if (quoteDataRec.hazardous != h) {
        quoteDataRec.hazardous = h;
        quoteDataRec.commodityType = "";
      }
      let cargo = [];
      let container = [];
      let obj = {};
      let multidest_new = [];
      if (multidest != undefined && shipmentType != undefined) {
        for (let i = 0; i < multidest.length; i++) {
          let z = {};
          z["destination"] = multidest[i]["destination"];
          z["cargoDetails"] = [];
          for (let j = 0; j < multidest[i]["cargoDetails"].length; j++) {
            let k = multidest[i]["cargoDetails"][j];
            k = Utils.setCargo_unit(
              k,
              multidest[0]["cargoDetails"][0],
              [
                "weight",
                "chargeableWeight",
                "volume",
                "totalWeight",
                "totalVolume",
                "dimensions",
              ],
              cargoDimensionUnit,
            );
            let c = Utils.convert_calcCargoDetails(
              multidest[i]["cargoDetails"][j],
              shipmentScope,
              shipmentType,
              showCargoDetailsOutGuage,
              cargoDimensionUnit,
              getValues("volumeInDimensions"),
            );
            z["cargoDetails"].push(c);
            cargo.push(c);
          }
          multidest_new.push(z);
        }
        if (
          JSON.stringify(multidest_new) !=
          JSON.stringify(quoteDataRec.multidest)
        ) {
          //quoteDataRec.multidest.length = 0
          quoteDataRec.multidest = JSON.parse(JSON.stringify(multidest_new));
        }
        if (containerDetails != undefined) {
          for (let j = 0; j < containerDetails.length; j++) {
            if (
              containerDetails[j]["containerType"] != undefined &&
              containerDetails[j]["containerType"].length > 0
            ) {
              let c = containerDetails[j]["containerType"];
              if (obj[c] == undefined) {
                obj[c] = {
                  containerType: "",
                  numContainers: 0,
                  unit: "",
                  wtPerContainer: 0,
                };
              }
              obj[c]["containerType"] = c;
              obj[c]["unit"] = "Kgs";
              obj[c]["numContainers"] =
                obj[c]["numContainers"] +
                Number(containerDetails[j]["numContainers"]);
              obj[c]["wtPerContainer"] = Number(
                Utils.toUnit(
                  containerDetails[j]["wtPerContainer"],
                  containerDetails[0]["unit"],
                ),
              );
            }
          }
        }
        let o = Object.keys(obj);
        for (let i = 0; i < o.length; i++) {
          container.push(obj[o[i]]);
        }
      }
      if (JSON.stringify(containerStore.list) != JSON.stringify(container)) {
        containerStore.list = JSON.parse(JSON.stringify(container));
      }
      if (JSON.stringify(cargoStore.cargoList) != JSON.stringify(cargo)) {
        cargoStore.cargoList = JSON.parse(JSON.stringify(cargo));
        cargoStore.calculateCargoTotals();
      }
    }
  }, [
    shipmentType,
    hazardous,
    shipmentScope,
    cargoReadinessDate,
    JSON.stringify(multidest),
    JSON.stringify(containerDetails),
  ]);

  useEffect(() => {
    setShow(false);
    setValue("fbaalways", "Yes");
    if (JSON.stringify(recdumb) != JSON.stringify(rec)) {
      setRecdumb(rec);
      if (
        rec.shipmentType.length > 3 &&
        rec.shipmentType.toLowerCase().indexOf("fcl") != -1
      ) {
        setValue("mode", "FCL");
        setType("FCL");
      } else {
        const type = rec.shipmentType === "" ? defaultType : rec.shipmentType;
        setValue("mode", type);
        setType(type);
      }
      if (
        quoteDataRec.shipmentType.toLowerCase().indexOf("lcl") != -1 &&
        (quoteDataRec.carrier == undefined ||
          quoteDataRec.carrier !=
            process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE)
      ) {
        quoteDataRec.carrier =
          process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE;
      }
      setValue("shipmentType", rec.shipmentType);
      setValue("scope", rec.shipmentScope);
      setValue("origin", rec.origin);
      setValue("cargoreadinessdate", rec.cargoReadinessDate);
      setValue("customerreference", rec.customerReferenceNum);
      setValue("hazardous", rec.hazardous === "No" ? false : true);
      setValue("quoteClass", rec.quoteClass);
      setValue("packingGroup", rec.packingGroup);
      setValue("temperature", rec.temperature);
      setValue("cargoValue", rec.cargoValue);
      setValue("unnumber", rec.unnumber);
      setValue("nonStackable", rec.nonStackable === "No" ? false : true);
      setValue(
        "temperatureControlled",
        rec.temperatureControlled === "No" ? false : true,
      );
      setValue("minTemperature", rec.minTemperature);
      setValue("maxTemperature", rec.maxTemperature);
      let stuffingtype =
        rec.stuffingType == undefined || rec.stuffingType == ""
          ? "Factory"
          : rec.stuffingType;
      let destuffingtype =
        rec.destuffingType == undefined || rec.destuffingType == ""
          ? "Factory"
          : rec.destuffingType;
      setValue("stuffingType", stuffingtype);
      setValue("destuffingType", destuffingtype);
      setValue("isFba", rec.fba === "Yes" ? true : false);
      setValue("warehouse", rec.warehouse);
      setValue("volumeInDimensions", rec.volumeInDimensions ?? true);
      setValue("ior", rec.fbaIorRequired === "Yes" ? true : false);
      setValue("iorParty", rec.iorParty ?? "Self");
      setValue("occ", rec.fbaOCC === "Yes" ? true : false);
      setValue("dcc", rec.fbaDCC === "Yes" ? true : false);
      setValue("opal",rec.opal)
      setValue("dpal",rec.dpal)
      setValue("survey", rec.fbaSurvey === "Yes" ? true : false);
      setValue("storageAtDestination", rec.fbaSAD === "Yes" ? true : false);
      setValue(
        "palletizationandlabelling",
        rec.fbaPAL === "Yes" ? true : false,
      );
      setValue("days", rec.fbaDays != undefined ? rec.fbaDays : 0);
      setValue(
        "pick_up_by_amazon",
        rec.pick_up_by_amazon === "Yes" ? true : false,
      );
      setValue("containerDetails", rec.containerDetails);
      if (rec.orginalCDU != undefined && rec.orginalCDU.length > 0) {
        setValue("cargoDimensionUnit", rec.orginalCDU);
      } else {
        setValue(
          "cargoDimensionUnit",
          rec.cargoDimensionUnit == undefined ? "Cms" : rec.cargoDimensionUnit,
        );
      }
      if (rec.orginalMD != undefined) {
        let m = watch("multidest");
        if (
          JSON.stringify(rec.orginalMD) != JSON.stringify(watch("multidest")) &&
          m != undefined
        ) {
          setValue("multidest", rec.orginalMD);
        }
      } else if (rec.multidest != undefined) {
        let m = watch("multidest");
        console.log("++++++++++++++++++++++++++82", m, rec.multidest);
        if (
          JSON.stringify(rec.multidest) != JSON.stringify(watch("multidest")) &&
          m != undefined
        ) {
          setValue("multidest", rec.multidest);
        }
      }
    }
    setShow(true);
  }, [rec]);
  


  if (
    quoteDataRec.shipmentType.toLowerCase().indexOf("fcl") != -1 &&
    quoteDataRec.emptycontainerweight == undefined
  ) {
    quoteDataRec.emptycontainerweight = "yes";
  }

  const setdata = async () => {
    //quoteDataRec.multidest = data.multidest
    const data = watch()
    console.log(" the data.warehouse ", data.warehouse);
    for (let i = 2; i < 6; i++) {
      delete quoteDataRec["destination" + i];
    }
    for (let i = 0; i < data.multidest.length; i++) {
      if (i == 0) {
        quoteDataRec.destination = data.multidest[i]["destination"];
      } else {
        let k = i + 1;
        quoteDataRec["destination" + k] = data.multidest[i]["destination"];
      }
    }
    quoteDataRec.nonStackable = data.nonStackable ? "Yes" : "No";
    quoteDataRec.cargoReadinessDate = data.cargoreadinessdate
    quoteDataRec.origin = data.origin;
    quoteDataRec.shipmentScope = data.scope;
    quoteDataRec.customerReferenceNum = data.customerreference;
    quoteDataRec.hazardous = data.hazardous ? "Yes" : "No";
    quoteDataRec.temperatureControlled = data.temperatureControlled
      ? "Yes"
      : "No";
    quoteDataRec.cargoDimensionUnit = "Cms";
    quoteDataRec.orginalCDU = cargoDimensionUnit;
    quoteDataRec.orginalMD = JSON.parse(JSON.stringify(multidest));
    quoteDataRec.unnumber = data.unnumber;
    quoteDataRec.packingGroup = data.packingGroup;
    quoteDataRec.quoteClass = data.quoteClass;
    quoteDataRec.stuffingType = data.stuffingType;
    quoteDataRec.destuffingType = data.destuffingType;
    quoteDataRec.minTemperature = data.minTemperature;
    quoteDataRec.maxTemperature = data.maxTemperature;
    quoteDataRec.temperature = data.temperature;
    quoteDataRec.cargoValue = data.cargoValue;
    quoteDataRec.warehouse = data.warehouse;
    quoteDataRec.volumeInDimensions = data.volumeInDimensions;
    quoteDataRec.fba = data.isFba ? "Yes" : "No";
    quoteDataRec.fbaIorRequired = data.ior ? "Yes" : "No";
    quoteDataRec.iorParty = data.iorParty;
    quoteDataRec.fbaOCC = data.occ ? "Yes" : "No";
    quoteDataRec.fbaDCC = data.dcc ? "Yes" : "No";
    quoteDataRec.opal = data.opal;
    quoteDataRec.dpal = data.dpal;
    quoteDataRec.fbaPAL = data.palletizationandlabelling ? "Yes" : "No";
    quoteDataRec.fbaSAD = data.storageAtDestination ? "Yes" : "No";
    quoteDataRec.fbaSurvey = data.survey ? "Yes" : "No";
    quoteDataRec.pick_up_by_amazon = data.pick_up_by_amazon ? "Yes" : "No";
    quoteDataRec.fbaDays = data.days != undefined ? data.days : 0;

    console.log(" the multidst of cargo details are ", quoteDataRec.multidest);
  };
  const checkcontainer = (containerDetails) => {
    let k = {};
    let l = true;
    for (let j = 0; j < containerDetails.length; j++) {
      if (
        containerDetails[j]["containerType"] != undefined &&
        containerDetails[j]["containerType"].length > 0
      ) {
        let c = containerDetails[j]["containerType"];
        if (k[c] == undefined) {
          k[c] = Number(containerDetails[j]["wtPerContainer"]);
        }
        if (k[c] != Number(containerDetails[j]["wtPerContainer"])) {
          configStore.setModalMessage(
            `Different Container Weight Not Allowed (${containerDetails[j]["containerType"]})`,
          );
          l = false;
        }
      }
    }
    return l;
  };

  return (
    <>
      {show ? (
        <>
          <div>
            <Headspan
              color="#555555"
              fontSize="20px"
              fontWeight="700"
              data={
                quoteDataRec.quotationNum != undefined &&
                quoteDataRec.quotationNum.length > 0
                  ? "Quotation Ref. No# "
                  : "Quotation"
              }
            />
            {quoteDataRec.quotationNum != undefined &&
            quoteDataRec.quotationNum.length > 0 ? (
              <Headspan
                color={process.env.REACT_APP_ENTERPRISE_COLOUR}
                fontSize="20px"
                fontWeight="700"
                data={quoteDataRec.quotationNum}
              />
            ) : (
              ""
            )}
          </div>
          <div class="columns is-vcentered is-multiline my-1">
            <Col3>
              {quoteDataRec.isfromAgragaEnquiry == "Yes" ? (
                <AgCustlist
                  {..._params("* Customer", "entityId", "select", entitieslist)}
                  isValid={
                    QuotationValidationStore.quotationValidMap["entityId"]
                  }
                  validationMsg="- Please select one of customers."
                  isDisabled={
                    quoteDataRec.quotationNum.indexOf("TBA") == -1
                      ? { disabled: true }
                      : {}
                  }
                  callback={(entityId) => {
                    QuotationValidationStore.validate("entityId");
                  }}
                />
              ) : (
                <AgCustlist
                  {..._params("* Customer", "entityId", "select", entitieslist)}
                  isValid={
                    QuotationValidationStore.quotationValidMap["entityId"]
                  }
                  validationMsg="- Please select one of customers."
                  isDisabled={
                    quoteDataRec.quotationNum !== "" ? { disabled: true } : {}
                  }
                  callback={(entityId) => {
                    QuotationValidationStore.validate("entityId");
                  }}
                />
              )}
            </Col3>
            <Col3 style={{ textAlign: "center", alignItems: "center" }}>
              {/* <span onClick={()=>setIsNomination(!isNomination)}> */}
              <span
                onClick={() => {
                  quoteDataRec.nomination = !quoteDataRec.nomination;
                  quoteDataRec.salesperson = "";
                  quoteDataRec.customerService = "";
                }}
              >
                <p>Nomination</p>
                {quoteDataRec.nomination ? (
                  <img height="36px" width="36px" src={on}></img>
                ) : (
                  <img height="36px" width="36px" src={off}></img>
                )}
              </span>
            </Col3>
            <Col3>
              <AgSelectNew
                {..._params(
                  "* Sales Person",
                  "salesperson",
                  "select",
                  agActiveList,
                )}
                // isValid={QuotationValidationStore.quotationValidMap["salesperson"]}
                // callback={() => QuotationValidationStore.validate("salesperson")}
                // validationMsg="- Please select valid salesperson."
              />
              {/* { quoteDataRec.entityId &&   (!quoteDataRec.salesperson   || quoteDataRec.salesperson === "" ) && ( !QuotationValidationStore.quotationValidMap.salesperson ||  QuotationValidationStore.quotationValidMap.salesperson == "" ) && 
              <p className="has-text-danger is-size-7">
              The Sales Person is not present.
              </p>
              } */}
            </Col3>
            <Col3>
              <AgSelectNew
                {..._params(
                  "* Customer Service",
                  "customerService",
                  "select",
                  agActiveList,
                )}
                // isValid={QuotationValidationStore.quotationValidMap["customerService"]}
                // callback={() => QuotationValidationStore.validate("customerService")}
                // validationMsg="- Please select valid Customer Service."
              />
              {/* { quoteDataRec.entityId &&   (!quoteDataRec.customerService   || quoteDataRec.customerService === "" ) && ( !QuotationValidationStore.quotationValidMap.customerService ||  QuotationValidationStore.quotationValidMap.customerService == "" ) && 
              <p className="has-text-danger is-size-7">
              The Customer Service is not present.
              </p>
              } */}
            </Col3>
          </div>

          <ActiveTab
            source="quotation"
            
            viewonly={
              quoteDataRec.quotationNum !== "" ||
              configStore.disableShipmentType !== ""
                ? true
                : false
            }
            selectedType={selectedType}
          />
          <div
            noValidate
            style={{ width: "100%", display: "flex", flexDirection: "column" }}
          >
            <div className="flex flex-row gap-[10px]">
              <Route form={cargoForm} viewonly={false} />
              <Details
                form={cargoForm}
                viewonly={false}
                applyDefault={quoteDataRec.quotationNum === ""}
              />
            </div>

            {
              <button
                style={{ float: "left", width: "430px", marginTop: "10px" }}
                className="button is-rounded is-small islink"
                onClick={() => {
                  // Rate request T&C are its custom T&C (pricing T&C), not the standard list
                  configStore.setModalMessage(
                    "",
                    [],
                    false,
                    String(quoteDataRec.customTC || "").split(/\r?\n/).map((t) => t.trim()).filter(Boolean),
                  );
                }}
              >
                Terms and Conditions
              </button>
            }
            <hr />
            <Card className="qoutecard">
              <div style={{ display: "flex", paddingLeft: "15px" }}>
                <span>
                  <img src={ship1} />
                </span>
                <Headspan
                  color="#00000"
                  fontSize="14px"
                  fontWeight="900"
                  data=" Port  Details"
                />
              </div>

              <div class="columns is-vcentered is-multiline m-1">
                <Col3>
                  <AgUnloc
                    {..._params(portOfReceiptLable, "portOfReceipt")}
                    isValid={
                      QuotationValidationStore.quotationValidMap[
                        "portOfReceipt"
                      ]
                    }
                    callback={(value, list) => {
                      QuotationValidationStore.validate("portOfReceipt");
                      QuotationValidationStore.quotationValidMap.portOfReceipt =
                        list.some((ele) => ele === value);
                    }}
                  />
                </Col3>
                <Col3>
                  <AgUnloc
                    {..._params(portOfLoadingLabel, "portOfLoading")}
                    isValid={
                      QuotationValidationStore.quotationValidMap[
                        "portOfLoading"
                      ]
                    }
                    callback={(value, list) => {
                      QuotationValidationStore.validate("portOfLoading");
                      QuotationValidationStore.quotationValidMap.portOfLoading =
                        list.some((ele) => ele === value);
                    }}
                  />
                </Col3>
                {quoteDataRec.shipmentType.indexOf("LCL") !== -1 && (
                  <Col3>
                    <AgUnloc
                      {..._params("Reworking Port", "reworkingPort")}
                      isValid={
                        QuotationValidationStore.quotationValidMap[
                          "reworkingPort"
                        ]
                      }
                      callback={(value, list) => {
                        QuotationValidationStore.validate("reworkingPort");
                        QuotationValidationStore.quotationValidMap.reworkingPort =
                          list.some((ele) => ele === value);
                      }}
                    />
                  </Col3>
                )}
                <Col3>
                  <AgUnloc
                    {..._params(portOfDischargeLabel, "portOfDischarge")}
                    isValid={
                      QuotationValidationStore.quotationValidMap[
                        "portOfDischarge"
                      ]
                    }
                    callback={(value, list) => {
                      QuotationValidationStore.validate("portOfDischarge");
                      QuotationValidationStore.quotationValidMap.portOfDischarge =
                        list.some((ele) => ele === value);
                    }}
                  />
                </Col3>
                <Col3>
                  <AgUnloc
                    {..._params(
                      "* Final Place of Delivery",
                      "finalPlaceOfDelivery",
                    )}
                    isValid={
                      QuotationValidationStore.quotationValidMap[
                        "finalPlaceOfDelivery"
                      ]
                    }
                    callback={(value, list) => {
                      QuotationValidationStore.validate("finalPlaceOfDelivery");
                      QuotationValidationStore.quotationValidMap.finalPlaceOfDelivery =
                        list.some((ele) => ele === value);
                    }}
                    validationMsg="- Please select enter valid UN location."
                  />
                </Col3>
              </div>
            </Card>

          <QuoteEditCharge  trigger={trigger} setOpenCopyMail={setOpenCopyMail} setdata={setdata} clickContract={clickContract} clickSave={clickSave} setClickSave={setClickSave} setClickContact={setClickContact} reviseCharges={reviseCharges} setReviseCharges={setReviseCharges}/>

            
            <hr />
                <Card className="qoutecard">
                  <Columns>
                    <Col12>
                      <h3 className="title is-5">Custom Terms & Conditions</h3>
                      <textarea
                        ref={ref}
                        value={quoteDataRec.customTC}
                        onChange={handleChange}
                        class="textarea"
                        placeholder=""
                      />
                    </Col12>
                  </Columns>
                </Card>
                {
                  !reviseCharges && <>
                  <hr />
            <Columns>
              <Col12>
                <div
                  className="field is-grouped"
                  style={{ display: "flex", justifyContent: "flex-start" }}
                >
                  {['PENDING','ACCEPTED'].indexOf(editapprovalStore.quote?.status)==-1 && <div className="control">
                    <button
                      className="button"
                      style={{
                        backgroundColor:
                          process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                        color: "#fff",
                      }}
                      onClick={(e) => {
                        e.nativeEvent.preventDefault();
                        e.preventDefault();
                        e.nativeEvent.stopPropagation();
                        e.stopPropagation();
                        setClickSave(true)
                      }}
                    >
                      {buttontext}
                    </button>
                    <button
                      className="button"
                      disabled={clickContract}
                      style={{
                        backgroundColor:
                          process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                        color: "#fff",
                      }}
                      onClick={(e) => {
                        e.nativeEvent.preventDefault();
                        e.preventDefault();
                        e.nativeEvent.stopPropagation();
                        e.stopPropagation();
                        setClickContact(true)
                      }}
                    >
                      Move to Contract
                    </button>
                  </div>}
                  <div className="control">
                    <button
                      class="button is-danger"
                      onClick={() => {
                        AgmodalStore.pageVisible = false;
                        AgmodalStore.apiCall = true;
                      }}
                    >
                      {['PENDING','ACCEPTED'].indexOf(editapprovalStore.quote?.status)==-1?"Cancel":"Close"}
                    </button>
                  </div>
                  
                </div>
              </Col12>
            </Columns>
                  </>
                }
                {openCopyMail &&
                                                                    <div className='modal is-active' >
                                                                        <div className="modal-background" ></div>
                                                                        <div className="modal-card" onClick={(e) => { e.stopPropagation() }} style={{ borderRadius: '10px', width: "90%" }} >
                                                                            <section className="modal-card-body">
                                                                                <CopyMail setOpenCopyMail={setOpenCopyMail} />
                                                                            </section>
                                                                        </div>
                                                                    </div>
                                                                }
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );
}
